import actionTypes from '../constants/action-types';

const fileSizeLimitReached = (assets, resolve, reject) => ({
  type: actionTypes.FILE_SIZE_LIMIT_REACHED,
  payload: {
    assets,
    resolve,
    reject,
  },
});

export default fileSizeLimitReached;
